import type { QueryBuilder } from "@cgarciagarcia/react-query-builder";

import { api } from "~/api";
import {
  importInsuranceProvidersResponseSchema,
  insuranceProvidersResponseSchema,
} from "./schemas";
import type { ImportInsuranceProviderParams } from "./types";

export const getInsuranceProviders = async ({
  queryBuilder,
}: {
  queryBuilder?: QueryBuilder<Record<string, string> | undefined>;
}) => {
  const response = await api.get(
    `/admin/insurance-providers${queryBuilder?.build() ?? ""}`,
  );

  return insuranceProvidersResponseSchema.parse(response.data);
};

export const getProviderMappings = async (providerId: number) => {
  const response = await api.get(
    `/admin/insurance-providers?filter[providerId]=${providerId}&limit=9999`,
  );

  return insuranceProvidersResponseSchema.parse(response.data);
};

export const importInsuranceProviders = async ({
  providerId,
  file,
}: ImportInsuranceProviderParams) => {
  const formData = new FormData();
  formData.append("file", file);

  const url = !providerId
    ? "/admin/insurance-providers/import"
    : `/admin/insurance-providers/${providerId}/import`;

  const response = await api.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return importInsuranceProvidersResponseSchema.parse(response.data);
};
